import { createAsyncThunk } from '@reduxjs/toolkit';

import islamicAgreementService from './islamicAgreementService';
import { restructureErrorMessage } from '../../helpers/errorMessage';

export const createIslamicAgreementThunk = createAsyncThunk(
  'islamicAgreement/create',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.createIslamicAgreement(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicPendingSigningAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getPendingSigningList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicPendingSigningAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicSignedAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getSignedList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicSignedAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicAgreementDetailsThunk = createAsyncThunk(
  'islamicAgreement/getDetails',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicAgreementDetails(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicPendingEStampAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getPendingEStampList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicPendingEStampAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicInProgressEStampAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getInProgressEStampList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicInProgressEStampAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicUploadedEStampAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getUploadedEStampList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicUploadedEStampAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const searchIslamicDisbursedAgreementThunk = createAsyncThunk(
  'islamicAgreement/searchDisbursedAgreement',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getIslamicAccountDetailsByAgreementNo(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const approveIslamicEStampingThunk = createAsyncThunk(
  'islamicAgreement/approveEStamping',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.approveIslamicEStamping(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const clickedDownloadIslamicEStampingThunk = createAsyncThunk(
  'islamicAgreement/clickedDownloadEStamping',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.clickedDownloadIslamicEStamping(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const disableIslamicDirectDebitThunk = createAsyncThunk(
  'islamicAgreement/disableDirectDebit',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.disableIslamicDirectDebit(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const clickedDownloadSmeIslamicEStampingThunk = createAsyncThunk(
  'islamicAgreement/clickedDownloadSmeEStamping',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.clickedDownloadSmeIslamicEStamping(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingTradingAgreementsThunk = createAsyncThunk(
  'islamicAgreement/getPendingTradingList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicAgreementService.getPendingTradingAgreements(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
